import React from 'react';
import { Section } from './ui/Section';
export function TheShift() {
  return <Section background="cream" data-id="element-155">
      <div className="max-w-4xl mx-auto border-l-4 border-[#7BA99E] pl-6 md:pl-12 py-4" data-id="element-156">
        <h2 className="text-3xl md:text-5xl font-serif text-[#4A4238] mb-6 leading-tight" data-id="element-157">
          In newborn season, the win is not "finished." <br data-id="element-158" />
          The win is <span className="text-[#7BA99E]" data-id="element-159">resettable</span>.
        </h2>

        <div className="space-y-4 text-lg md:text-xl text-[#4A4238]" data-id="element-160">
          <p data-id="element-161">A home where you can clear one surface and breathe.</p>
          <p data-id="element-162">A body that can downshift in under 90 seconds.</p>
          <p data-id="element-163">A brain that knows what the next 2 hours are.</p>
        </div>

        <p className="mt-8 text-xl font-medium text-[#8C7E6E] font-serif italic" data-id="element-164">
          That's the calm baseline.
        </p>
      </div>
    </Section>;
}